var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"mouseover":function($event){_vm.modalVisible=true},"mouseleave":function($event){_vm.modalVisible=false}}},[_c('download-button',{attrs:{"type":"pages","cssClass":"card__button","url":_vm.item.file,"title":_vm.fileName(_vm.item),"icon":true}}),_c('download-modal',{attrs:{"download":_vm.item,"visible":_vm.modalVisible}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }